import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-section-header',
    template: `
   <div class="mb-6">
    <div class="flex align-items-center mb-2">
      <div class="flex align-items-center justify-content-center" style="width: 5em; height: 3rem;">
        <img [src]="iconPath" [alt]="title" class="w-full">
      </div>
      <h2 class="text-2xl font-semibold text-900 m-0">{{ title }}</h2>
    </div>
    <p-divider/>
   </div>
  `,
    standalone: false
})
export class SectionHeaderComponent {
  @Input() title!: string;
  @Input() iconPath!: string;
}